module.exports = __webpack_public_path__ + "assets/img/dagger.3d0273b5.png";